import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-info\"><defs><style type=\"text/css\"></style></defs><path d=\"M677.312 64l23.36 128.512H896V960H128V192.576l197.888-0.064L347.968 64h329.344z m129.536 218.304H217.152v587.904h589.696V282.304z m-290.24 351.168V723.2H331.776v-89.728h184.832z m188.16-216.512v89.792H331.712V416.96H704.64z m-101.76-263.168H423.04l-6.72 38.72h193.728l-7.04-38.72z\" p-id=\"2733\" fill=\"#666666\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol